export const API_BASE_URL = '/api/generic-onboarding/v1/client-data';

export enum PathApi {
  ENGINEER_DATA = 'engineer/data',
}

export const SESSION_ID_HEADER_NAME = 'x-session-id';
